import Translate from '@components/atoms/Translate/Translate'
import BackBtn from '@components/molecules/BackBtn/BackBtn'
import Button from '@components/molecules/Button/Button'
import {
  FETCH_STATUS_ERROR,
  FETCH_STATUS_IDLE,
  FETCH_STATUS_PENDING,
  ROUTE_SELECT,
  ROUTE_SHOWMOCK,
} from '@config/constants'
import {
  actionPostUpload,
  actionResetCompositeUpload,
  actionResetCompositeUploadState,
  actionSetStep,
} from '@store/reducers/app'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './StepUpload.module.scss'
import Text from '@components/atoms/Text/Text'
import Upload from '@components/molecules/Upload/Upload'
import LightBox from '@components/molecules/LightBox/LightBox'
import { useNavigate } from 'react-router-dom'
import Split from '@components/layouts/Split'

import { sendEvent } from '@utils/tracking'

const StepUpload = () => {
  const dispatch = useDispatch()
  const gtmEvent = {
    name: 'Sujet testen - Step 2, Klick auf Mockup generieren nach Upload',
    category: 'sujet testen',
    action: 'Step 2 - Upload done, Mockup generieren',
  }

  useEffect(() => {
    dispatch(actionSetStep(1))
  }, [])

  const {
    serializedFile,
    selectedSujet,
    stateComposition,
    compositeError,
    compositeImages,
  } = useSelector((state) => state.app)

  const onGenerateClick = async () => {
    dispatch(
      actionPostUpload({
        sujetId: selectedSujet.id,
        base64Str: serializedFile.content,
        type: serializedFile.type,
      })
    )
    sendEvent(gtmEvent.name, gtmEvent.category, gtmEvent.action)
  }

  const navigate = useNavigate()

  const navigateToPreview = () => {
    navigate(ROUTE_SHOWMOCK, { replace: true })
  }

  useEffect(() => {
    if (stateComposition === FETCH_STATUS_IDLE) {
      dispatch(actionResetCompositeUploadState())
      navigateToPreview()
    }
  }, [stateComposition])

  const onErrorClose = () => {
    dispatch(actionResetCompositeUpload())
  }

  const isPending = stateComposition === FETCH_STATUS_PENDING
  const isFinished = !!compositeImages
  const showGenerateButton = serializedFile && !isFinished
  const clickAllowed = stateComposition === false
  const isError = stateComposition === FETCH_STATUS_ERROR

  return (
    <Split>
      <>
        {(isError && (
          <LightBox
            body={compositeError}
            title={<Translate str="steps.upload.error.server" />}
            buttons={<Button onClick={onErrorClose}>OK</Button>}
            onClose={onErrorClose}
          />
        )) ||
          false}

        <BackBtn link={ROUTE_SELECT} />
      </>
      <div className={styles.center}>
        <div className={styles.headline}>
          <Text type="h2">
            <Translate str="steps.upload.headline" />
          </Text>
        </div>
        <div className={styles.description}>
          <Text type="text-m">
            <Translate str="steps.upload.description" />
          </Text>
        </div>

        <div className={styles.upload}>
          <Upload />
        </div>

        {(showGenerateButton && (
          <div className={styles.cta}>
            <Button
              icon="arrow-long-right"
              onClick={onGenerateClick}
              disabled={!clickAllowed}
            >
              <Translate
                str={isPending ? 'steps.upload.ctaPending' : 'steps.upload.cta'}
              />
            </Button>
          </div>
        )) ||
          null}

        {(isFinished && (
          <div className={styles.cta}>
            <Button
              icon="arrow-long-right"
              onClick={() => {
                navigateToPreview()
              }}
            >
              <Translate str="steps.upload.ctaNext" />
            </Button>
          </div>
        )) ||
          null}
      </div>
    </Split>
  )
}

export default StepUpload
